enum CompetitorsPriceRateAlertRuleInclusion {
    ALL = "ALL",
    ANY = "ANY",
    SOME = "SOME"
}

export default CompetitorsPriceRateAlertRuleInclusion;